import { MidasOfferPageData } from 'types/order-join-flow';
import { simpleSegment } from './segment';

const SIMPLE_SEGMENT_ELIGIBILITY_FIELD = 'midas_user_segments';

export const isSegmentEligibleForOffer = (
  segment: string,
  offer: MidasOfferPageData,
): boolean => {
  const resolvedSegment = simpleSegment(segment) || segment;
  const segments =
    offer?.attributes?.[SIMPLE_SEGMENT_ELIGIBILITY_FIELD]?.data ?? [];
  return Array.isArray(segments)
    ? segments.some(
        (item) =>
          item?.attributes?.name?.toLowerCase() ===
          resolvedSegment.toLowerCase(),
      )
    : false;
};
